import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import Uuid from '@/services/Uuid'

@Module({name: 'UserModule'})
export default class UserModule extends VuexModule {
    currentUserId = ''

    @Mutation
    setUserId(userId: string) {
        this.currentUserId = userId
    }

    @Action
    generateUserId() {
        this.context.commit('setUserId', new Uuid().uuidv4() + Date.now())
        console.log(this.userId)
    }

    get userId() {
        return this.currentUserId
    }
}